import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getWarehouseItemList,
	addNewWarehouseItem,
	updateWarehouseItem,
	deleteWarehouseItem,
	getWarehouseItem,
	checkWarehouseItemExists,
	reserveWarehouseItem,
	deliverWarehouseItem,
	returnWarehouseItem,
	pickWarehouseItem,
	receiveWarehouseItem,
	releaseWarehouseItem,
	deliverWarehouseItemStockCheck
} from '../warehouseItem/thunk';

export const initialState = {
	warehouseItemList: [],
	itemWarehouseItem: null,
	isWarehouseItemLoading: false,
	isWarehouseItemSuccess: false,
	isCheckStock: false,
	isCheckStockOk: false,
	checkStockErrors: null,

	dataWarehouseItem: null,
	statementList: [],
	statementListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
	registerDisabled: false,
	requireReloadSelectionItemsGrid: false,
	exists: false
};

const WarehouseItemSlice = createSlice({
	name: 'WarehouseItems',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
		setWarehouseItemList(state, action){
			state.warehouseItemList = action.payload;
		}
	},
	extraReducers: builder => {
		builder.addCase(getWarehouseItem.fulfilled, (state, action) => {
			state.isWarehouseItemLoading = false;
			state.isWarehouseItemSuccess = true;
			state.itemWarehouseItem = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getWarehouseItem.pending, state => {
			state.isWarehouseItemLoading = true;
			state.isWarehouseItemSuccess = null;
			state.itemWarehouseItem = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getWarehouseItem.rejected, (state, action) => {
			state.isWarehouseItemLoading = false;
			state.isWarehouseItemSuccess = false;
			state.itemWarehouseItem = null;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(getWarehouseItemList.pending, state => {
			state.isWarehouseItemSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getWarehouseItemList.fulfilled, (state, action) => {
			state.warehouseItemList = action.payload;
			state.statementList = action.payload;
			state.isLoadingList = false;
			state.isWarehouseItemSuccess = true;

			let statementListSelect = [];
			action.payload.map(item =>
				statementListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.statementListSelect = statementListSelect;
		});
		builder.addCase(getWarehouseItemList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isWarehouseItemSuccess = true;
		});
		builder.addCase(addNewWarehouseItem.fulfilled, (state, action) => {
			state.warehouseItemList.push(action.payload);
			state.statementList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewWarehouseItem.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewWarehouseItem.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateWarehouseItem.fulfilled, (state, action) => {
			state.warehouseItemList = state.warehouseItemList.map(warehouseItem =>
				warehouseItem._id.toString() === action.payload._id.toString()
					? {
						...warehouseItem,
						...action.payload
					}
					: warehouseItem
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateWarehouseItem.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateWarehouseItem.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteWarehouseItem.fulfilled, (state, action) => {
			state.warehouseItemList = current(state.warehouseItemList).filter(
				item => item._id !== action.payload._id
			);
			state.statementList = current(state.statementList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteWarehouseItem.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteWarehouseItem.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});

		

		builder.addCase(checkWarehouseItemExists.fulfilled, (state, action) => {
			state.exists = false;
			if (action.payload === true)
				state.exists = true;
		});
		builder.addCase(checkWarehouseItemExists.pending, (state, action) => {
			state.exists = false;
		});
		builder.addCase(checkWarehouseItemExists.rejected, (state, action) => {
			state.exists = false;
		});




		
		builder.addCase(reserveWarehouseItem.fulfilled, (state, action) => {
			state.isWarehouseItemLoading = false;
			state.isWarehouseItemSuccess = true;
			state.itemWarehouseItem = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(reserveWarehouseItem.pending, state => {
			state.isWarehouseItemLoading = true;
			state.isWarehouseItemSuccess = null;
			state.itemWarehouseItem = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(reserveWarehouseItem.rejected, (state, action) => {
			state.isWarehouseItemLoading = false;
			state.isWarehouseItemSuccess = false;
			state.itemWarehouseItem = null;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(deliverWarehouseItem.fulfilled, (state, action) => {
			state.isWarehouseItemLoading = false;
			state.isWarehouseItemSuccess = true;
			state.itemWarehouseItem = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(deliverWarehouseItem.pending, state => {
			state.isWarehouseItemLoading = true;
			state.isWarehouseItemSuccess = null;
			state.itemWarehouseItem = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(deliverWarehouseItem.rejected, (state, action) => {
			state.isWarehouseItemLoading = false;
			state.isWarehouseItemSuccess = false;
			state.itemWarehouseItem = null;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(returnWarehouseItem.fulfilled, (state, action) => {
			state.isWarehouseItemLoading = false;
			state.isWarehouseItemSuccess = true;
			state.itemWarehouseItem = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(returnWarehouseItem.pending, state => {
			state.isWarehouseItemLoading = true;
			state.isWarehouseItemSuccess = null;
			state.itemWarehouseItem = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(returnWarehouseItem.rejected, (state, action) => {
			state.isWarehouseItemLoading = false;
			state.isWarehouseItemSuccess = false;
			state.itemWarehouseItem = null;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(pickWarehouseItem.fulfilled, (state, action) => {
			state.isWarehouseItemLoading = false;
			state.isWarehouseItemSuccess = true;
			state.itemWarehouseItem = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(pickWarehouseItem.pending, state => {
			state.isWarehouseItemLoading = true;
			state.isWarehouseItemSuccess = null;
			state.itemWarehouseItem = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(pickWarehouseItem.rejected, (state, action) => {
			state.isWarehouseItemLoading = false;
			state.isWarehouseItemSuccess = false;
			state.itemWarehouseItem = null;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(receiveWarehouseItem.fulfilled, (state, action) => {
			state.isWarehouseItemLoading = false;
			state.isWarehouseItemSuccess = true;
			state.itemWarehouseItem = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(receiveWarehouseItem.pending, state => {
			state.isWarehouseItemLoading = true;
			state.isWarehouseItemSuccess = null;
			state.itemWarehouseItem = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(receiveWarehouseItem.rejected, (state, action) => {
			state.isWarehouseItemLoading = false;
			state.isWarehouseItemSuccess = false;
			state.itemWarehouseItem = null;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(releaseWarehouseItem.fulfilled, (state, action) => {
			state.isWarehouseItemLoading = false;
			state.isWarehouseItemSuccess = true;
			state.itemWarehouseItem = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(releaseWarehouseItem.pending, state => {
			state.isWarehouseItemLoading = true;
			state.isWarehouseItemSuccess = null;
			state.itemWarehouseItem = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(releaseWarehouseItem.rejected, (state, action) => {
			state.isWarehouseItemLoading = false;
			state.isWarehouseItemSuccess = false;
			state.itemWarehouseItem = null;
			state.error = action.error.message;
			state.isLoadingList = false;
		});
		builder.addCase(deliverWarehouseItemStockCheck.fulfilled, (state, action) => {
			state.isCheckStock = false;
			state.isCheckStockOk = true;
			state.checkStockErrors = null;
		});
		builder.addCase(deliverWarehouseItemStockCheck.pending, state => {
			state.isCheckStock = true;
			state.isCheckStockOk = false;
			state.checkStockErrors = null;
		});
		builder.addCase(deliverWarehouseItemStockCheck.rejected, (state, action) => {
			console.log('action.payload', action)
			state.isCheckStock = false;
			state.isCheckStockOk = false;
			state.checkStockErrors = {
				message:
					action.payload?.detail?.message ||
					action.payload?.message ||
					"Error al comprobar stock",

				errors:
					action.payload?.detail?.errors ||
					action.payload?.errors ||
					[],
			};
		});
	},
});

export const {
	setRequireCloseModal,
	setWarehouseItemList,
} = WarehouseItemSlice.actions;

export default WarehouseItemSlice.reducer;